import React from 'react'
import '../Style/UserSetting.css'
import SectionSelector from '../Components/UserSectionSelector'
import ProfilePicture from '../Profile_Pictures/1662741205554.jpg'
import { Link, useParams } from 'react-router-dom'


function UserSettings() {
    const { Section } = useParams()
    return (
        <>
            <main>
                <div className='user-setting-container'>
                    <div className='user-profile-container'>
                        <div className='profile-container'>
                            <div className='name-and-texts'>
                                <div className='username'>LingoMan</div>
                                {/* <div className='information'>test</div> */}

                            </div>
                            <div className='user-picture' style={{ backgroundImage: `url(${ProfilePicture})` }}></div>
                        </div>
                        <div className='sections-container'>
                            <Link to={"/user/security"} className={Section === "security" ? "sections-active" : "sections-normal"}>امنیت</Link>
                            <div className='wrapper'></div>
                            <Link to={"/user/address"} className={Section === "address" ? "sections-active" : "sections-normal"}>اطلاعات ادرس</Link>
                            <div className='wrapper'></div>
                            <Link to={"/user/personal-info"} className={Section === "personal-info" ? "sections-active" : "sections-normal"}>اطلاعات خصوصی</Link>
                            <div className='wrapper'></div>
                            <Link to={"/user/public-info"} className={!Section || Section === "public-info" ? "sections-active" : "sections-normal"}>اطلاعات عمومی</Link>
                        </div>
                    </div>
                    <SectionSelector />
                </div>
            </main>
        </>
    )
}

export default UserSettings